// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__cPlFN","label":"Labeled_label__2sfMP","divider":"Labeled_divider__30owX"};